import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExportParameter } from '../../../../../Model/exportParameter/ExportParameter';
import { ModelService } from '../../../../../Services/model.service';
import { firstValueFrom } from "rxjs";
import { WawiSettingsService } from "../../../../../Services/wawiSettingsService.service";
import {LanguageFlag} from "../../../../../Model/Dto/LanguageFlag";
import {ViewService} from "../../../../../Services/view.service";

@Component({
    selector: 'exportConfiguration',
    templateUrl: './exportConfiguration.component.html',
    styleUrls: ['./exportConfiguration.component.css'],
    standalone: false
})
export class ExportConfigurationComponent implements OnInit {
    @Input() exportParameter: ExportParameter;
    @Input() popupOpen = false;
    bmeDialects = ['NexMart', 'E/D/E Multishop', 'E/D/E Multishop no root', 'Onventis', 'SCIREUM_SELLSITE', 'HUBWOO', "ETIM5"];
    imageTypes = ['jpg', 'png'];
    public wawiFields: string[];

    constructor(public modelService: ModelService, public translate: TranslateService, public wawiSettingsService: WawiSettingsService) {
        this.bmeDialectChanged = this.bmeDialectChanged.bind(this);
    }

    async ngOnInit() {


    }
    
  get possibleLanguages(): LanguageFlag[] {
    return ViewService.languages;
  }
  
    ngOnChanges() {
        if (this.popupOpen) {
            this.onPopupOpened();
        }
    }

    private async onPopupOpened() {
        if (this.wawiFields != undefined) return;

        this.wawiFields = [];
        var allWawiFields = await firstValueFrom(this.wawiSettingsService.getWawiSettings(this.modelService.loginService.currentCustomer.id));
        this.wawiFields = allWawiFields.customFields.filter(x => x.fieldType != "Mapping").map(x => x.name);

        if (allWawiFields.hasLine1)
            this.wawiFields.push("line1");
        if (allWawiFields.hasLine2)
            this.wawiFields.push("line2");
        if (allWawiFields.hasLine3)
            this.wawiFields.push("line3");
        if (allWawiFields.hasLine4)
            this.wawiFields.push("line4");
    }

    public bmeDialectChanged() {
        if (this.exportParameter.bmeDialect == 'SCIREUM_SELLSITE') {
            this.exportParameter.useMediaUrl = true;
        }
    }

    get isScireum() {
        return this.exportParameter.version == 'SCIREUM_SELLSITE';
    }

    get isDpbCatalog() {
        return this.exportParameter.version == 'DPB_CATALOG';
    }

    get isBmeCatFormat() {
        return this.exportParameter.format == 'BME';
    }

    get isOnboarding() {
        return this.modelService.loginService.hasAddonONBOARDING;
    }

    get hasAddonPackaging() {
        return this.modelService.loginService.hasAddonPackaging;
    }

    get showExportBrandNameAsTechnicalFeature() {
        var result = this.exportParameter.version == 'SCIREUM_SELLSITE' ||
            this.exportParameter.version == 'SYMBIONET' ||
            this.exportParameter.version == 'WESCALE' ||
            this.exportParameter.version == 'GEVIS' ||
            this.exportParameter.version == 'ELECTRONIC_SALES' ||
            this.exportParameter.version == 'SMARTSTORE';
        return result;
    }
}
